<template>
    <div class="time-on-internet fadeInRight">
        <div class="title-box clearfix">
            <span class="m-title">在网时长统计</span>
            <el-form inline ref="quaryForm" v-model="quaryForm" class="right themed-form search-form" style="height: auto;line-height: 40px;">
                <el-form-item>
                    <el-input v-model="quaryForm.iccidMark" placeholder="ICCID号" class="iccid-width"></el-input>
                </el-form-item>
                  <el-form-item>
                    <el-input v-model="quaryForm.shortIccid" placeholder="短号" class="iccid-width"></el-input>
                </el-form-item>

                 <el-form-item label="代理商名称">
                    <el-select filterable v-model="quaryForm.agentId">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item,index) in agentIdList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
					<el-button icon="el-icon-search" type="primary" class="themed-button" @click="onSearch">查询</el-button>
				</el-form-item> 
                <el-form-item>
					<el-button icon="el-icon-download" class="themed-button" type="info" @click="exportExcel">导出Excel</el-button>
				</el-form-item>             
            </el-form>
        </div>

        <div class="content-box">
            <el-table
                border
                ref="table"
                stripe
                :max-height="maxTableHeight"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                >
                <el-table-column
                    show-overflow-tooltip
                    prop="iccidMark"
                    label="ICCID号"
                    min-width="180"
                    >
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="shortIccid"
                    label="短号"
                    min-width="120"
                    />
                <el-table-column
                    show-overflow-tooltip
                    prop="agentName"
                    label="代理商"
                    min-width="150"
                    >
                </el-table-column>
                 <el-table-column
                    show-overflow-tooltip
                    prop="accountName"
                    label="运营商"
                    min-width="150"
                    >
                </el-table-column>
                 <el-table-column
                    show-overflow-tooltip
                    prop="agentFirstName"
                    label="所属总代理"
                    min-width="150"
                    >
                </el-table-column>
                
                <el-table-column
                    show-overflow-tooltip
                    prop="useNum"
                    label="累计在网时长"
                    min-width="150"
                    >
                </el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    prop="status"
                    label="当前状态"
                    min-width="120"
                    >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==1">待激活</span>
                        <span v-else-if="scope.row.status==2">正常</span>
                        <span v-else-if="scope.row.status==3">断网</span>
                        <span v-else-if="scope.row.status==4">停机</span>
                        <span v-else-if="scope.row.status==5">异常</span>
                        <span v-else-if="scope.row.status==7">注销</span>
                    </template>
                </el-table-column>
                
                <el-table-column
                    show-overflow-tooltip
                    prop="createTime"
                    label="统计时间"
                    min-width="120"
                    >
                </el-table-column>
            </el-table>
            <el-pagination :current-page.sync="quaryForm.pageNo"  :page-sizes="[5,10,15,50,100,1000]" :page-size="quaryForm.pageSize" style="text-align: left;margin-top: 20px;"
			 background layout="total,sizes,prev, pager, next,jumper" :total="total" @size-change="handleSizeChange" @current-change="onPageChange"></el-pagination>
        </div>
    </div>
</template>

<script>
import resize from '@/mixins/resize.js'
import {getOnLineTime,exportOnLineTime} from "@/api/operationalStatistics/operationalStatistics.js";
import {getAgentList} from "@/api/agentManagement.js"
export default {
    mixins:[resize],
    data(){
        return {
            quaryForm:{
                pageNo:1,
                pageSize:15,
                agentId:'',
                iccidMark:'',
                shortIccid:"",
            },
            tableData:[],
            total:0,
            agentIdList:[]
        }
    },
    created(){
        this.getList()
        this.getAgentList()
    },
    methods: {
        getList(){
            getOnLineTime(this.quaryForm).then(res=>{
                this.tableData=res.rows
                this.total = res.count
            })
        },

        getAgentList(){
            getAgentList().then(res=>{
				this.agentIdList = res
			})
        },

        onPageChange(page){
			this.quaryForm.pageNo = page
			this.getList()
		},
		handleSizeChange(size){
			this.quaryForm.pageSize = size
			this.getList()
        },

        onSearch(){
            this.quaryForm.pageNo=1
            this.getList()
        },

        exportExcel(){
            let params = {
                agentId:this.quaryForm.agentId,
                iccidMark:this.quaryForm.iccidMark,
                shortIccid:this.quaryForm.shortIccid,
            }
            exportOnLineTime(params).then(res=>{
					if (res.system_result_key == '0') {
						this.$alert('导出成功，请到导出记录中下载', '提示', {
						    confirmButtonText:'确定',
						}).then(()=>{
							this.$router.push('/tob/i_export_list')
						});
					}else{
						this.$message({
						    showClose: true,
						    message: res.system_result_message_key,
						    type: 'error'
						});
					}
				})
        }
    },
}
</script>

<style>
    .time-on-internet .el-form-item__label{
        vertical-align: top;
    }
</style>